// extracted by mini-css-extract-plugin
export var content = "_ph-1";
export var fullScreen = "_ph-0";